import React from 'react';
import { Controller } from 'react-hook-form';
import { InputBaseComponentProps, TextField, TextFieldProps } from '@mui/material';
import { FormComponentProps } from './FormComponentProps';
import { FieldValues } from 'react-hook-form/dist/types';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface Props<TFieldValues>
  extends FormComponentProps<TFieldValues>,
    Omit<NumericFormatProps, 'name'> {
  endAdornment?: JSX.Element;
  startAdornment?: JSX.Element;
}

const FixedDecimalFormatCustom = React.forwardRef<typeof NumericFormat, InputBaseComponentProps>(
  (props, ref) => {
    const { onChange, defaultValue, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          console.log('onValueChange', values);
          (onChange as any)({
            target: {
              name: props.name,
              value: values.floatValue != null ? values.floatValue : null,
            },
          });
        }}
        onBlur={() => {
          console.log('onBlur', props.value);
          if (props.onBlur) {
            (props.onBlur as any)({
              target: {
                name: props.name,
                value: props.value,
              },
            });
          }
        }}
        decimalSeparator=","
        thousandSeparator="."
        fixedDecimalScale
        decimalScale={2}
        onFocus={(e) => e.target.select()}
        allowNegative={false}
      />
    );
  }
);

// this component is used in edge-cases where FormNumberInput with custom scale leads to issues
export const FormFixedNumberInput = <TFieldValues extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  className,
  shrink,
  disableUnderline,
  endAdornment,
  startAdornment,
  readOnly,
  onBlur,
  ...others
}: Props<TFieldValues> & TextFieldProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState, fieldState: { error } }) => (
        <TextField
          error={!!error}
          {...field}
          // value={field.value as number}
          label={label}
          placeholder={placeholder}
          className={className}
          fullWidth={true}
          variant="standard"
          sx={
            others.required && !error && !others.disabled
              ? {
                  '& .MuiInput-underline:not(.Mui-focused):before': {
                    borderBottom: '2px solid black',
                  },
                  '& .MuiInput-underline:not(.Mui-focused):after': {
                    borderBottom: '2px solid black',
                  },
                }
              : undefined
          }
          InputProps={{
            inputComponent: FixedDecimalFormatCustom,
            endAdornment,
            disableUnderline,
            startAdornment,
            readOnly,
          }}
          helperText={error ? error.message : undefined}
          InputLabelProps={{ shrink }}
          onBlur={(e) => {
            console.log('fieldBlur', formState);
            if (onBlur && formState.dirtyFields[field.name]) {
              onBlur(e);
            }
            field.onBlur();
          }}
          {...others}
        />
      )}
    />
  );
};
